/**
 * Formatação dos números exibidos nas telas.
 *
 * Num painel que decide compra, o mesmo número escrito de dois jeitos em duas telas
 * ("1234.5" numa, "1.234,5" na outra) faz o leitor desconfiar de que são valores
 * diferentes. A formatação mora num lugar só por isso.
 */

/** Número com separador de milhar e vírgula decimal pt-BR, e casas fixas. */
export function formatNumber(value: number, precision = 0): string {
  return value.toLocaleString("pt-BR", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
}

/** Comprimento de contexto em milhares de tokens de base dois ("8192" → "8k"). */
export function formatContext(tokens: number): string {
  return `${(tokens / 1024).toFixed(0)}k`;
}

/**
 * Lê o número digitado num campo, caindo no valor padrão quando não é número.
 *
 * Campo apagado chega como texto vazio, que `Number` converteria para zero — e zero de
 * tarifa ou de câmbio produz divisão por zero no cálculo de retorno. Vazio e lixo voltam
 * ao padrão, que é o valor que a tela mostra quando abre.
 */
export function parseNumberInput(raw: string, fallback: number): number {
  if (raw.trim() === "") {
    return fallback;
  }
  const parsed = Number(raw.replace(",", "."));
  return Number.isFinite(parsed) ? parsed : fallback;
}

/**
 * Prende o valor entre o mínimo e o máximo.
 *
 * O campo de texto aceita qualquer número; o cálculo não. Câmbio abaixo de 1 ou regime
 * acima das 8.760 horas de um ano produziriam um retorno que parece medido e não é.
 */
export function clampNumber(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
